import http from '@root/utils/axios/admin';

let state = {
    Statistics: [],
    UserEntryCounts: [],
}

let actions = {

    fetchGetStatistics({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/get-statistics-new', { params: filter }).then((response) => {
                commit('setStatistics', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGetUserEntryCounts({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/get-user-entry-counts', { params: filter }).then((response) => {
                commit('setUserEntryCounts', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchGameChart({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/statistics/games/chart', { params: filter }).then((response) => {
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },


}


let mutations = {
    setStatistics(state, data) {
        state.Statistics = data;
    },
    setUserEntryCounts(state, data) {
        state.UserEntryCounts = data;
    },

}

export default {
    state,
    actions,
    mutations
}